"use client";

import Link from "next/link";

import { EventKeys } from "@/lib/observability/catalog";
import { EventPublisher } from "@/lib/observability/events";
import { routes } from "@/lib/routes";

/**
 * Client component for hero section buttons with event tracking
 */
export function HeroButtons() {
  const handleGetStartedClick = () => {
    void EventPublisher.publishEvent(
      EventKeys.PUBLIC_GET_STARTED_BUTTON_CLICK,
      {},
    );
  };

  const handleLearnMoreClick = () => {
    void EventPublisher.publishEvent(
      EventKeys.PUBLIC_SEE_HOW_IT_WORKS_BUTTON_CLICK,
      {},
    );
  };

  return (
    <div className="flex flex-wrap gap-4">
      <Link
        aria-label="Get started with NeedBridge for free"
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 font-semibold"
        href={routes.auth.register()}
        onClick={handleGetStartedClick}
      >
        Try Free
      </Link>
      <Link
        aria-label="Learn more about how NeedBridge works"
        className="bg-gray-200 text-gray-800 px-6 py-3 rounded-lg hover:bg-gray-300 font-medium"
        href={routes.public.howItWorks()}
        onClick={handleLearnMoreClick}
      >
        See How It Works
      </Link>
    </div>
  );
}

/**
 * Client component for CTA section buttons with event tracking
 */
export function CTAButtons() {
  const handleSignUpClick = () => {
    void EventPublisher.publishEvent(
      EventKeys.PUBLIC_GET_STARTED_BUTTON_CLICK,
      {},
    );
  };

  const handleDemoClick = () => {
    void EventPublisher.publishEvent(
      EventKeys.PUBLIC_VIEW_NEEDS_BUTTON_CLICK,
      {},
    );
  };

  return (
    <div className="flex flex-wrap justify-center gap-4">
      <Link
        aria-label="Get started with NeedBridge for free"
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 font-semibold"
        href={routes.auth.register()}
        onClick={handleSignUpClick}
      >
        Try Free
      </Link>
      <Link
        aria-label="Watch a demo of NeedBridge"
        className="bg-white text-blue-600 border border-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 font-medium"
        href={routes.public.demo()}
        onClick={handleDemoClick}
      >
        Watch Demo
      </Link>
    </div>
  );
}
